"use client";

import { Input } from "@/components/ui/input";
import {
  setUmrahFilters,
  useUmrahFilter,
} from "@/feature/umrah/package/search/state/extract-umrah-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { UmrahAccordion } from "./umrah-accordion";

export function UmrahNameFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption } = useAppSelector(useUmrahFilter);

  return (
    <UmrahAccordion value="umrah_name" label="Package Name">
      <Input
        value={selectedOption.query}
        onChange={(event) => {
          dispatch(setUmrahFilters({ query: event.target.value }));
        }}
        placeholder="Search package title"
      />
    </UmrahAccordion>
  );
}
